import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../style/report.css";

function Report() {
  const navigate = useNavigate();
  const [selectedReport, setSelectedReport] = useState("today");

  const todayData = [
    { flatNo: "A101", reading: 250, difference: 10 },
    { flatNo: "B202", reading: 320, difference: 15 },
    { flatNo: "C303", reading: 410, difference: 20 }
  ];

  const historyData = [
    { flatNo: "A101", reading: 240, difference: 8 },
    { flatNo: "B202", reading: 305, difference: 12 },
    { flatNo: "C303", reading: 390, difference: 18 }
  ];

  return (
    <div className="home-container">
      <nav className="navbar">
        <div className="logo">💧</div>
      </nav>

      <div className="content">
        <div className="text-content">
          <h2 className="special">View Report</h2>
          <p className="description">Select a report type to view details.</p>

          <div className="report-buttons">
            <button className="report-btn" onClick={() => setSelectedReport("today")}>Today</button>
            <button className="report-btn" onClick={() => setSelectedReport("history")}>History</button>
          </div>

          {selectedReport && (
            <div className="confirmation-boxx">
            <table className="report-table">
              <thead>
                <tr>
                  <th>Flat No.</th>
                  <th>Reading</th>
                  <th>Difference</th>
                </tr>
              </thead>
              <tbody>
                {(selectedReport === "today" ? todayData : historyData).map((item, index) => (
                  <tr key={index}>
                    <td>{item.flatNo}</td>
                    <td>{item.reading}</td>
                    <td>{item.difference}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          )}
        </div>
      </div>
      <footer className="bottom-nav">
        <button className="nav-btn" onClick={() => navigate("/home")}>Home</button>
        <button className="nav-btn" onClick={() => navigate("/menu")}>Readings</button>
        <button className="nav-btn" onClick={() => navigate("/report")}>Report</button>
      </footer>
    </div>
  );
}

export default Report;
